<template>
    <div class="formatted-stepper d-flex align-items-center">
        <button class="btn btn-sm btn-light border" @click="decrease" :disabled="disabled || (min !== null && value <= min)">
            <i class="fas fa-minus small"></i>
        </button>
        <money-input 
            class="form-control form-control-sm text-center mx-1 p-1 font-weight-bold border-0" 
            :value="value" 
            @input="onInput"
            :style="{ width: inputWidth, background: 'transparent' }"
        />
        <button class="btn btn-sm btn-light border" @click="increase" :disabled="disabled || (max !== null && value >= max)">
            <i class="fas fa-plus small"></i>
        </button>
    </div>
</template>

<script>
export default {
    name: 'FormattedStepper',
    props: {
        value: {
            type: [Number, String],
            default: 0
        },
        min: {
            type: Number,
            default: 1
        },
        max: {
            type: Number,
            default: null
        },
        step: {
            type: Number,
            default: 1
        },
        disabled: {
            type: Boolean,
            default: false
        },
        inputWidth: {
            type: String,
            default: '60px'
        }
    },
    methods: {
        onInput(val) {
            this.$emit('input', val);
            this.$emit('change', val); // Compatibility
        },
        decrease() {
            let newVal = Number(this.value) - this.step;
            if (this.min !== null && newVal < this.min) newVal = this.min;
            this.onInput(newVal);
        },
        increase() {
            let newVal = Number(this.value) + this.step;
            if (this.max !== null && newVal > this.max) newVal = this.max;
            this.onInput(newVal);
        }
    }
}
</script>

<style scoped>
.formatted-stepper button {
    width: 28px;
    height: 28px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
}
</style>
